var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2999 11.4006V18.8866C13.3379 19.1716 13.2429 19.4756 13.0244 19.6751C12.9365 19.7632 12.8321 19.833 12.7172 19.8807C12.6022 19.9284 12.479 19.9529 12.3546 19.9529C12.2302 19.9529 12.107 19.9284 11.9921 19.8807C11.8772 19.833 11.7728 19.7632 11.6849 19.6751L9.77538 17.7656C9.67183 17.6643 9.59309 17.5404 9.5453 17.4036C9.49751 17.2668 9.48197 17.1209 9.49988 16.9771V11.4006H9.47138L3.99938 4.38959C3.84511 4.19154 3.7755 3.94048 3.80576 3.69127C3.83602 3.44206 3.96369 3.21496 4.16088 3.05959C4.34138 2.92659 4.54088 2.85059 4.74988 2.85059H18.0499C18.2589 2.85059 18.4584 2.92659 18.6389 3.05959C18.8361 3.21496 18.9637 3.44206 18.994 3.69127C19.0243 3.94048 18.9547 4.19154 18.8004 4.38959L13.3284 11.4006H13.2999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.b5eaa425407141ecefb6d2e88095ce50.svg";
export { ForwardRef as ReactComponent };